import { gql } from "@apollo/client";

export const getProductionLinesCorporateBO = gql`
    query GetProductionLines($millId: Int!) {
        production_line(where: { mill_id: { _eq: $millId } }, order_by: { created_at: asc }) {
            production_line_id
            name
            code
            mill {
                mill_id
                corporate_id
                mill_modules(where: { module_type_id: { _eq: 3 } }) {
                    is_enabled
                }
                shifts {
                    shift_id
                    name
                    start_time
                    end_time
                    shift_days {
                        day {
                            day_id
                            name
                            default_day_translations {
                                default_day_translation_id
                                language {
                                    language_id
                                    name
                                }
                                translated_name
                            }
                        }
                    }
                }
            }
            machine_centers(order_by: { created_at: asc }, where: { disabled_at: { _is_null: true } }) {
                machine_center_id
                name
                short_name
                is_bottleneck
                production_line_id
                hmi_code
                downtime_method_capture {
                    downtime_method_capture_id
                    name
                }
                plc_address
                manufacturer
                model_number
                order
                cluster {
                    mill {
                        cluster_enabled
                    }
                    mill_id
                    cluster_id
                    name
                    is_enabled
                    cluster_code
                    machine_centers {
                        machine_center_id
                        name
                        order
                        cluster {
                            cluster_id
                            name
                            machine_centers {
                                machine_center_id
                                name
                            }
                        }
                        production_line {
                            production_line_id
                            name
                        }
                    }
                }
            }
            production_line_shifts(where: { disabled_at: { _is_null: true } }) {
                production_line_shift_id
                effective_at
                shift {
                    name
                    shift_id
                    start_time
                    end_time
                    shift_days {
                        day {
                            name
                            day_id
                            default_day_translations {
                                default_day_translation_id
                                language {
                                    language_id
                                    name
                                }
                                translated_name
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const getProductionLinesOptionsBO = gql`
    query getProductionLinesOptionsBO($mill_id: Int!) {
        production_line(where: { mill_id: { _eq: $mill_id }, machine_centers: { machine_center_id: { _gt: 0 } } }) {
            production_line_id
            name
            machine_centers(order_by: { created_at: asc }, where: { disabled_at: { _is_null: true } }) {
                machine_center_id
                name
            }
        }
    }
`;

export const insertProductionLineCorporateBO = gql`
    mutation insertProductionLine($productionLine: production_line_insert_input!) {
        insert_production_line_one(
            object: $productionLine
            on_conflict: { constraint: production_line_pkey, update_columns: [name, code] }
        ) {
            production_line_id
            production_line_shifts {
                production_line_shift_id
            }
        }
    }
`;

export const getAllProductionLines = gql`
    query GetAllProductionLines {
        production_line {
            mill {
                mill_id
                name
            }
            production_line_id
            name
        }
    }
`;

export const getProductionLinesAndHMIs = gql`
    query getProductionLinesAndHMIs($mill_id: Int!) {
        production_line(where: { mill_id: { _eq: $mill_id } }) {
            production_line_id
            name
            machine_centers(where: { disabled_at: { _is_null: true } }) {
                machine_center_id
                name
                cluster {
                    cluster_id
                    name
                    machine_centers(where: { disabled_at: { _is_null: true } }) {
                        machine_center_id
                        name
                    }
                }
            }
        }
        corporate {
            corporate_id
        }
    }
`;
